import { CaseState } from 'app/area/case/types-store';
import get from 'lodash/get';

export const connectedDrafts = 
  (state: CaseState) => ({ connectedDrafts: get(state, 'editing.connectedDrafts') as any[] });
